// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textarea/Controlled.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextArea, css } from '@sail/ui';
export const Controlled = () => {
  const [textValue, setTextValue] = React.useState();
  return <TextArea value={textValue} onChange={e => {
    setTextValue(e.target.value); // eslint-disable-next-line no-console

    console.log(e.target.value);
  }} label="About your business" placeholder="Our business is…" css={{
    width: css.value('350px')
  }} />;
};